module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 p-t-15"
  }, [_c('div', [_vm._v("Font-Size")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('themeChange', _vm.themeObj)
      }
    },
    model: {
      value: (_vm.themeObj.font_size),
      callback: function($$v) {
        _vm.$set(_vm.themeObj, "font_size", $$v)
      },
      expression: "themeObj.font_size"
    }
  }, _vm._l((_vm.allFontSizes), function(fontSize, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": fontSize,
        "value": fontSize
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 p-t-15"
  }, [_c('div', [_vm._v("Font-Style")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('themeChange', _vm.themeObj)
      }
    },
    model: {
      value: (_vm.themeObj.font_family),
      callback: function($$v) {
        _vm.$set(_vm.themeObj, "font_family", $$v)
      },
      expression: "themeObj.font_family"
    }
  }, _vm._l((_vm.googleFontList), function(font, id) {
    return _c('el-option', {
      key: id,
      attrs: {
        "label": ("" + (font.text)),
        "value": font.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-t-15"
  }, [_c('div', {
    staticClass: "col-md-2 atd-theme-group"
  }, [_c('div', [_vm._v("Font Color")]), _vm._v(" "), _c('swatch', {
    staticStyle: {
      "width": "50px",
      "height": "42px"
    },
    attrs: {
      "colors": "text-advanced",
      "popover-to": "top",
      "show-fallback": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('themeChange', _vm.themeObj)
      }
    },
    model: {
      value: (_vm.themeObj.font_color),
      callback: function($$v) {
        _vm.$set(_vm.themeObj, "font_color", $$v)
      },
      expression: "themeObj.font_color"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 atd-theme-group"
  }, [_c('div', [_vm._v("CTA Color")]), _vm._v(" "), _c('swatch', {
    staticStyle: {
      "width": "50px",
      "height": "42px"
    },
    attrs: {
      "colors": "text-advanced",
      "popover-to": "top",
      "show-fallback": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('themeChange', _vm.themeObj)
      }
    },
    model: {
      value: (_vm.themeObj.cta_color),
      callback: function($$v) {
        _vm.$set(_vm.themeObj, "cta_color", $$v)
      },
      expression: "themeObj.cta_color"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 atd-theme-group"
  }, [_c('div', [_vm._v("Background Color")]), _vm._v(" "), _c('swatch', {
    staticStyle: {
      "width": "50px",
      "height": "42px"
    },
    attrs: {
      "colors": "text-advanced",
      "show-fallback": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('themeChange', _vm.themeObj)
      }
    },
    model: {
      value: (_vm.themeObj.background_color),
      callback: function($$v) {
        _vm.$set(_vm.themeObj, "background_color", $$v)
      },
      expression: "themeObj.background_color"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b9ef696!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/bidder/Theme.vue
// module id = 677
// module chunks = 2